import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=4b0613f7&"
import script from "./LoginHeader.vue?vue&type=script&lang=js&"
export * from "./LoginHeader.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/content.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/font.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports